import styled from 'styled-components'

export const Form = styled.form`
  max-width: 560px;
`

export const FormTitle = styled.h2`
  margin-bottom: 2rem;
`

export const Description = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: #585d64;
  max-width: 435px;
  margin: 0 0 2rem;
`

export const BottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 50px;

  button {
    margin-left: 30px;
  }
`
